import React from "react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function ZigzagTimelineTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl p-8 shadow-2xl text-[13px] leading-relaxed" data-testid="resume-live-preview">
      <div className="text-center mb-4">
        <h1 className="text-2xl font-bold">{draft.full_name || "Your Name"}</h1>
        {draft.target_role && <p className="text-sm font-semibold mt-0.5" style={{ color: accent }}>{draft.target_role}</p>}
        <p className="text-slate-500 text-[11px] mt-2">{[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join("  •  ")}</p>
      </div>
      {draft.summary && <p className="text-slate-700 text-center mb-5">{draft.summary}</p>}

      {draft.experience.length > 0 && (
        <div className="mb-5 relative">
          <div className="absolute left-1/2 top-0 bottom-0 w-px bg-slate-200" />
          {draft.experience.map((e, i) => (
            <div key={i} className={`w-1/2 mb-4 ${i % 2 === 0 ? "pr-5 text-right ml-0" : "pl-5 text-left ml-auto"}`}>
              <p className="font-semibold text-slate-800">{e.title}</p>
              <p className="text-[12px]" style={{ color: accent }}>{e.company} · {dateRange(e.start_date, e.end_date, e.current)}</p>
              <ul className={`text-slate-700 mt-0.5 ${i % 2 === 0 ? "list-none" : "list-disc list-inside"}`}>{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
            </div>
          ))}
        </div>
      )}
      {draft.education.length > 0 && (
        <div className="mb-4 text-center">
          <h2 className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}>Education</h2>
          {draft.education.map((ed, i) => <p key={i} className="text-slate-700">{ed.degree} {ed.field} — {ed.school}</p>)}
        </div>
      )}
      {draft.skills.length > 0 && (
        <div className="mb-4 text-center">
          <h2 className="text-xs font-bold uppercase tracking-wider mb-2" style={{ color: accent }}>Skills</h2>
          <p className="text-slate-700">{draft.skills.join(", ")}</p>
        </div>
      )}
      <ExtraResumeSections draft={draft} accent={accent} />
    </div>
  );
}
